import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppEventsControllerService {
  private appReadySubject = new Subject<void>();
  appReady$ = this.appReadySubject.asObservable();

  appReady(): void {
    console.log('Fire appReady.');
    this.appReadySubject.next();
    this.appReadySubject.complete();
  }
}
